export const parseResponseForSelectInput = (data: any[]) => {
  return data.reduce((result, { id, name }) => {
    return [...result, { value: id, key: id, title: name }];
  }, []);
};
